"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_CACHE_DURATION_MS = exports.SYSTEM_INFORMATION_CACHE_DURATION_MS = exports.READ_SYMLINK_CACHE_DURATION_MS = exports.SYS_CMD_SEARCH_CACHE_DURATION_MS = exports.DOTNET_INFORMATION_CACHE_DURATION_MS = exports.SUDO_LOCK_PING_DURATION_MS = exports.LOCAL_LOCK_PING_DURATION_MS = exports.GLOBAL_LOCK_PING_DURATION_MS = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
exports.GLOBAL_LOCK_PING_DURATION_MS = 50;
exports.LOCAL_LOCK_PING_DURATION_MS = 10;
exports.SUDO_LOCK_PING_DURATION_MS = 20;
exports.DOTNET_INFORMATION_CACHE_DURATION_MS = 9000;
exports.SYS_CMD_SEARCH_CACHE_DURATION_MS = 30000;
exports.READ_SYMLINK_CACHE_DURATION_MS = 4000;
exports.SYSTEM_INFORMATION_CACHE_DURATION_MS = 1200000;
exports.WEB_CACHE_DURATION_MS = 300000;
//# sourceMappingURL=CacheTimeConstants.js.map